const Inspector = wp.blockEditor.InspectorControls;

Inspector.Body = wp.components.PanelBody;
Inspector.Row = wp.components.PanelRow;

export default Inspector;